import React, { useContext } from "react";
import SocketContext from "../providers/Socket";
import useConfig from "../hooks/use-config";
const text = {
    en: {
        title: "Something Went Wrong!",
        please_try: "Please try to",
        page: "the page",
        refresh: "refresh"
    },
    ar: {
        title: "حدث خطأ!",
        please_try: "يرجى محاولة",
        page: "الصفحة",
        refresh: "تحديث"
    }
};
const MainContainer = (props) => {
    const { isConnectionFailed } = useContext(SocketContext);
    let { lang } = useConfig();
    let Header = () => React.createElement(React.Fragment, null);
    if (isConnectionFailed)
        Header = () => React.createElement("div", { className: "alert alert-danger alert-dismissible fade show pt-3 pb-3" },
            React.createElement("strong", null, text[lang].title),
            " ",
            text[lang].please_try,
            " ",
            React.createElement("span", { onClick: () => window.location.reload(), style: {
                    textDecoration: "underline",
                    cursor: "pointer"
                } }, text[lang].refresh),
            " ",
            text[lang].page);
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, null),
        props.children));
};
export default MainContainer;
